// 현장 연결 코드 모양·정규화 — node:crypto 없는 한 벌이라 서버(connect-code)와 화면(/connect)이 같이 쓴다.

// 헷갈리는 0·O·1·I 를 뺀 32자.
export const CONNECT_CODE_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
export const CONNECT_CODE_LENGTH = 8;
// 0132 project_connect_code_format 과 같은 모양.
const CONNECT_CODE_FORMAT = /^[A-Z0-9]{8,12}$/;

// 고객이 친 값 — 대문자로 올리고 하이픈·공백 등 영숫자 밖을 턴다.
export const connectCodeOf = (raw: string): string => raw.toUpperCase().replace(/[^A-Z0-9]/g, "");

// 모양이 틀리면 null.
export const normalizeConnectCode = (raw: string): string | null => {
  const code = connectCodeOf(raw);
  return CONNECT_CODE_FORMAT.test(code) ? code : null;
};

export const isPhoneLast4 = (value: string): boolean => /^\d{4}$/.test(value);

// 화면 「연결」 버튼이 켜지는 조건 — 서버가 받는 모양과 같다.
export const connectReady = (code: string, last4: string): boolean => normalizeConnectCode(code) !== null && isPhoneLast4(last4);
